import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthNewService } from '../../../service/auth-new.service';
import { delay } from 'rxjs/operators';
import { access } from 'fs';
import { StorageService } from '../../../service/storage.service';

@Component({
  selector: 'app-user-sign-in',
  templateUrl: './user-sign-in.component.html',
  styleUrls: ['./user-sign-in.component.scss']
})
export class UserSignInComponent implements OnInit, OnDestroy {

  signinForm!: FormGroup;
  codeForm!: FormGroup;
  submitted = false;
  username!: string;
  password!: string;
  code!: string;
  user!: CognitoUser;
  userAuthenticated = false;
  mfaFlag = false;
  userGroup = new BehaviorSubject<string>('');
  hide = true;
  error: string;
  userRole: string;
  MfaUser
  private currentLoginUser: Subscription;
  resendEnabled: boolean = false;
  resendTimeout: any;
  codeReceived;
  TokenAccess

  constructor(public formBuilder: FormBuilder, public router: Router, private authservice: AuthNewService,
    private storageService: StorageService) {
    this.resendTimeout = setTimeout(() => {
      this.resendEnabled = true;
    }, 20000);
  }

  ngOnInit(): void {
    this.resendEnabled = false;
    this.error = ''
    this.signinForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.codeForm = this.formBuilder.group({
      code: ['', Validators.required]
    });
  }
  get formControls() { return this.signinForm.controls; }
  get formControls1() { return this.codeForm.controls; }

  signInNew() {

    this.submitted = true;
    this.userAuthenticated = false;
    if (this.signinForm.invalid) {
      return;
    }

    this.username = this.signinForm.value.username;
    this.password = this.signinForm.value.password;
    this.authservice.signIn(this.username, this.password);



    this.authservice.signinError.subscribe((error) => {

      if (error) {
        this.submitted = false;
        this.error = 'Username or Password is incorrect.';
      } else {
        this.error = '';
      }
    })
    this.authservice.user.subscribe((user: any) => {

      if (user) {
        if (user.challengeName === 'SMS_MFA') {
          this.codeReceived = user.challengeParam['CODE_DELIVERY_DESTINATION']

          this.mfaFlag = true;
        } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.router.navigate(['/extra-layout/new-password']);
        } else {

          this.authservice.getAuthenticatedUser().getSession((err, session) => {
            if (err) {
              console.log('Error in getting Session forwarding to login page');

            }
            const credential = session.getIdToken().getJwtToken();
            const tokenParts = credential.split('.');
            const payload = JSON.parse(atob(tokenParts[1]));
            this.TokenAccess = payload['custom:access'];
          })

          const storedData = this.storageService.get('access');
          if (this.TokenAccess == storedData) {
            this.storageService.set('Authorization','true')
            if (storedData == 'QA') {
              this.router.navigate(['default-layout/user-details'])
            }
            else
              this.router.navigate(['default-layout/previous-analysis'])
          }
          else {
            console.log("Unauthorized User");
            this.storageService.set('Authorization','false')
            this.router.navigate(['default-layout/page-401']);
          }
        }
      }
    })
  }

  confirmationCode() {
    this.code = this.codeForm.value.code;
    // this.authservice.confirmCode(this.code);
    this.authservice.confirmCode(this.code, (error, newUser) => {
      if (error) {
        // Handle error when confirmation code is incorrect
        console.error(error);
        this.error = 'Incorrect Confirmation Code';
      } else {

        if (newUser?.signInUserSession) {
          this.userAuthenticated = true;
          this.user = newUser;

          this.authservice.getMFACurrentUser();
          this.currentLoginUser = this.authservice.MfaUser.subscribe((user) => {
            this.userRole = this.storageService.get('access');

            if (this.userRole == 'QA') {
              this.router.navigate(['default-layout/user-details']);
            } else {
              this.router.navigate(['default-layout/previous-analysis']);
            }
          });
        }
      }
    })

  }

  clearError() {
    this.error = '';
  }
  resendOTP(): void {
    this.error = null
    this.signInNew();
    this.resendEnabled = false;
    clearTimeout(this.resendTimeout);
    this.resendTimeout = setTimeout(() => {
      this.resendEnabled = true;
    }, 20000);

  }



  ngOnDestroy() {
    // Unsubscribe from the observable to avoid memory leaks
    clearTimeout(this.resendTimeout);
    if (this.currentLoginUser) {
      this.currentLoginUser.unsubscribe();
    }
  }
}
